import React, { useRef } from 'react';
import { CheckIcon, ImagePlusIcon, Trash2Icon } from 'lucide-react';
import { themes } from '../../data/themes';
import { PRIX_PHOTO_PERSO } from '../../data/options';
import { formatPrix } from '../../utils/price';
type Props = {
  themeId: string;
  photoPerso: string | null;
  onSelectTheme: (id: string) => void;
  onUpload: (url: string) => void;
  onRemovePhoto: () => void;
};
export function ThemePicker({
  themeId,
  photoPerso,
  onSelectTheme,
  onUpload,
  onRemovePhoto
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fichier = event.target.files?.[0];
    if (fichier) onUpload(URL.createObjectURL(fichier));
    event.target.value = '';
  };
  return <div data-id="element-61" data-mp="lbdwp3bpts31">
      <p className="text-sm font-medium text-ink" data-id="element-62" data-mp="3a0lrrytap0s8">Choisissez un visuel</p>
      <div className="mt-3 grid grid-cols-3 gap-3 sm:grid-cols-4" data-id="element-63" data-mp="39yr6gje436nm">
        {themes.map(theme => {
        const actif = !photoPerso && theme.id === themeId;
        return <button key={theme.id} type="button" aria-pressed={actif} onClick={() => onSelectTheme(theme.id)} className="group text-left" data-id="element-64" data-mp="2aib894idqhkl">
              <span className={`relative block overflow-hidden rounded-full border-2 transition-colors duration-150 ease-out ${actif ? 'border-forest' : 'border-transparent group-hover:border-forest/40'}`} data-id="element-65" data-mp="21j68xvyzuk7d">
                <img src={theme.image} alt={theme.nom} className="aspect-square w-full scale-105 object-cover" data-id="element-66" data-mp="1wj1s24u6bngm" />
                {actif && <span className="absolute bottom-1 right-1 flex h-5 w-5 items-center justify-center rounded-full bg-forest text-cream" data-id="element-67" data-mp="1mpurcxadovmv">
                    <CheckIcon className="h-3 w-3" data-id="element-68" data-mp="1drr2br06pgqb" />
                  </span>}
              </span>
              <span className="mt-2 block text-xs leading-snug text-muted" data-id="element-69" data-mp="3fgopb2xfo1lp">{theme.nom}</span>
            </button>;
      })}

        <div data-id="element-70" data-mp="3aodntvn1o7r1">
          <button type="button" onClick={() => inputRef.current?.click()} aria-pressed={Boolean(photoPerso)} className={`relative flex aspect-square w-full items-center justify-center overflow-hidden rounded-full border-2 border-dashed transition-colors duration-150 ease-out ${photoPerso ? 'border-forest' : 'border-line bg-parchment text-muted hover:border-forest/50 hover:text-forest'}`} data-id="element-71" data-mp="3anvh252rab4v">
            {photoPerso ? <img src={photoPerso} alt="Votre photo" className="h-full w-full object-cover" data-id="element-72" data-mp="3kgazf3hyt1qa" /> : <ImagePlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-73" data-mp="2e0gzu5pa2a5s" />}
          </button>
          <span className="mt-2 block text-xs leading-snug text-muted" data-id="element-74" data-mp="28zbbsl6kbb2l">
            Ma photo <span className="whitespace-nowrap" data-id="element-75" data-mp="oj3ed0f6srzt">+ {formatPrix(PRIX_PHOTO_PERSO)}</span>
          </span>
        </div>
      </div>

      <input ref={inputRef} type="file" accept="image/*" className="sr-only" onChange={handleFile} aria-label="Importer votre photo" data-id="element-76" data-mp="thws8tydyl0i" />

      {photoPerso ? <button type="button" onClick={onRemovePhoto} className="mt-4 inline-flex items-center gap-1.5 text-xs text-terracotta hover:text-terracotta-dark" data-id="element-77" data-mp="12b02yuhncjrg">
          <Trash2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-78" data-mp="1c61s3qbx9lu1" />
          Retirer ma photo et revenir aux modèles
        </button> : <p className="mt-4 text-xs leading-relaxed text-muted" data-id="element-79" data-mp="1l8b46kmu9n9j">
          Photo personnelle : format carré conseillé, 1500 px minimum. Nous recadrons et retouchons
          votre image avant impression, puis vous envoyons un bon à tirer.
        </p>}
    </div>;
}